const Config = {
	TICK_SPACING_ROTATION_BREAKPOINT: 102,
	CALCULATION_FUNCTIONS: {
		rotationAmount: (tickSpacing) => -Math.PI / Math.max(tickSpacing / 8, 2),
		rotatedSpace: (rotationAmount) => Math.max(48, (360 / Math.abs(rotationAmount)) * 0.13),
		inferRange: (numTicks) => (numTicks <= 10 ? "AT MOST 10" : "MORE THAN 10"),
	},
	RANGE_SETTINGS: {
		"AT MOST 10": {
			MAX_ROTATABLE_TABLE_WIDTH: 836,
		},
		"MORE THAN 10": {
			MAX_ROTATABLE_TABLE_WIDTH: 1328,
		},
	},
};

export default Config;
